import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { usePocket } from "@/contexts/PocketContext";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { SubmitHandler, useForm } from "react-hook-form";

const LoginSchema = z.object({
  email: z.string().email(),
  password: z.string(),
});

type LoginSchemaType = z.infer<typeof LoginSchema>;

export function LoginForm() {
  const { login } = usePocket();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginSchemaType>({
    resolver: zodResolver(LoginSchema),
  });

  const onSubmit: SubmitHandler<LoginSchemaType> = ({ email, password }) => login(email, password);

  return (
    <Card className="mx-auto max-w-sm w-full">
      <CardHeader>
        <CardTitle className="text-2xl">Войти</CardTitle>
        <CardDescription>Введите email и пароль</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" placeholder="m@example.com" required {...register("email")} />
          </div>
          <div className="grid gap-2">
            <div className="flex items-center">
              <Label htmlFor="password">Пароль</Label>
              {/*<a href="#" className="ml-auto inline-block text-sm underline">*/}
              {/*  Forgot your password?*/}
              {/*</a>*/}
            </div>
            <Input id="password" type="password" required {...register("password")} />
          </div>
          <Button type="submit" className="w-full">
            Войти
          </Button>
          {/*<Button variant="outline" className="w-full">*/}
          {/*  Login with Google*/}
          {/*</Button>*/}
        </form>
        {/*<div className="mt-4 text-center text-sm">*/}
        {/*  Don&apos;t have an account?{" "}*/}
        {/*  <a href="#" className="underline">*/}
        {/*    Sign up*/}
        {/*  </a>*/}
        {/*</div>*/}
      </CardContent>
    </Card>
  );
}
